import React from 'react'
import Text from '../../atoms/Text'

const GRADE_STYLE_MAP = {
  A: {
    bg: 'bg-[#FFF]',
    border: 'bg-border-secondary',
    titleColor: 'text-[#101828]',
    bodyColor: 'text-[#667085]',
  },
  B: {
    bg: 'bg-[#FFF]',
    border: 'bg-border-secondary',
    titleColor: 'text-[#101828]',
    bodyColor: 'text-[#667085]',
  },
  C: {
    bg: 'bg-[#FFF]',
    border: 'bg-border-secondary',
    titleColor: 'text-[#101828]',
    bodyColor: 'text-[#667085]',
  },
  D: {
    bg: 'bg-[#FFF]',
    border: 'bg-border-secondary',
    titleColor: 'text-[#101828]',
    bodyColor: 'text-[#667085]',
  },
  // A: {
  //   bg: 'bg-[#F0FDF4]',
  //   border: 'border-[#BBF7D0]',
  //   titleColor: 'text-[#166534]',
  //   bodyColor: 'text-[#15803D]',
  // },
  // B: {
  //   bg: 'bg-[#FFFBEB]',
  //   border: 'border-[#FDE68A]',
  //   titleColor: 'text-[#92400E]',
  //   bodyColor: 'text-[#A16207]',
  // },
  // C: {
  //   bg: 'bg-[#FFF7ED]',
  //   border: 'border-[#FED7AA]',
  //   titleColor: 'text-[#7C2D12]',
  //   bodyColor: 'text-[#C2410C]',
  // },
  // D: {
  //   bg: 'bg-[#FEF2F2]',
  //   border: 'border-[#FECACA]',
  //   titleColor: 'text-[#991B1B]',
  //   bodyColor: 'text-[#B91C1C]',
  // },
}

const PotassiumSummaryCard = ({
  grade = 'A',
  title = 'Potassium Guidance',
  summary = '',
  className = '',
}) => {
  const style = GRADE_STYLE_MAP[grade] || GRADE_STYLE_MAP.A

  return (
    <div
      className={`p-4 ${style.bg} border ${style.border} rounded-xl ${className}`}
    >
      <Text
        tag={'p'}
        variant={'label'}
        size={'medium'}
        bold={'true'}
        className={`${style.titleColor} mb-2`}
      >
        {title}
      </Text>
      <Text
        tag={'p'}
        variant={'body'}
        size={'medium'}
        className={style.bodyColor}
      >
        {summary}
      </Text>
    </div>
  )
}

export default PotassiumSummaryCard
